import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";
import FormControlComponent from "../../components/dashboard/form-control";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from "@material-ui/lab/Alert";
import MainTable from "./MainTable";
import MainCalendar from "./MainCalendar";
import NotesDisplay from "./NotesDisplay";
import JournalAddNote from "../journal/add-journal-note";
import CompareMain from "../compare/CompareMain";
import { useDispatch, useSelector } from "react-redux";
import { addUsers } from "../../store/actions/userAction";
// import Dialog from "screens/dialog/CustomizedDialog";
import SearchButton from "./SearchButton";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import DownloadReportMain from "../Report/downloadReportMain";
import { DEFAULT_ALERT } from "utils/strings";
import { useNavigate } from "react-router-dom";
import {
    setName,
    setLastName,
    setProfile,
    setRole,
    setUserId,
    setEmail,
} from "../../store/actions/authActions";

export default function Dashboard() {
    const axios = useAxiosPrivate();
    const dispatch = useDispatch();
    const accessUser = useSelector((state) => state?.user);
    const authState = useSelector((state) => state?.auth);
    const selectedUserIds = accessUser?.data?.map((user) => user?.user_id);
    const navigate = useNavigate();

    const [group, setGroup] = useState("");
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "success",
        message: "",
    });
    const [groupData, setGroupData] = useState([]);
    const formName = "Pick Team";
    const [selectedDays, setSelectedDays] = useState([]);
    const [open, setOpen] = useState(false);
    const [note, setNote] = useState({});
    const [date, setDate] = useState(new Date());
    const [noteDetails, setNoteDetails] = useState([]);
    const [readJournal, setReadJournal] = useState(false);
    const [members, setMembers] = useState([]);
    // Initialize userValue from Redux state to preserve selections when navigating back
    const [userValue, setUserValue] = useState(() => accessUser?.data || []);
    const [fData, setFData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [count, setCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [user, setUser] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [openDownloadReport, setOpenDownloadReport] = useState(false);

    const selectedCount = selectedUserIds?.length || 0;
    const isCompareDisabled = selectedCount < 2 || selectedCount > 6;
    const compareTooltipTitle =
        selectedCount < 2
            ? "Select at least 2 people to compare."
            : selectedCount > 6
              ? "Select up to 6 people to compare. Please reduce your selection."
              : "";

    const getJournalData = async (newMonth = null) => {
        let targetDate = newMonth || date;
        let month = ("0" + (targetDate.getMonth() + 1)).slice(-2);

        // Only fetch profile if we need groups and don't have them yet
        // NavBar should have already loaded profile data into Redux
        let groupsList = [];

        if (groupData.length === 0) {
            // Only call profile API if groups are not already loaded
            // This happens on initial load or if groups haven't been fetched yet
            try {
                const profile = await axios.get("/user/profile");
                const profileData = profile.data.data;

                // Update Redux store with profile data (in case NavBar hasn't loaded it yet)
                if (!authState.name || !authState.email) {
                    dispatch(setName(profileData.first_name));
                    dispatch(setLastName(profileData.last_name));
                    dispatch(setRole(profileData.role));
                    dispatch(setProfile(profileData.avatar_url));
                    dispatch(setUserId(profileData.id));
                    dispatch(setEmail(profileData.email));
                }

                groupsList = profileData.groups || [];
            } catch (error) {
                console.error("Error fetching profile for groups:", error);
                // If API fails, try to continue with empty groups
                groupsList = [];
            }
        } else {
            // Use existing groups, but remove the "All" item if it exists to get fresh groups
            groupsList = groupData
                .filter((g) => g.id !== "")
                .map((g) => ({
                    id: g.id,
                    name: g.name,
                    category: g.category,
                    category_id: g.category_id,
                    coach_id: g.coach_id,
                    coach_name: g.coach_name,
                }));
        }

        const all = {
            id: "",
            name: "All",
            category: "All",
            category_id: "N/A",
            coach_id: "N/A",
            coach_name: "N/A",
        };
        // add item all to the beginning of the array
        groupsList.unshift(all);
        setGroupData(groupsList);

        const { data } = await axios.post(
            `/journal/${targetDate.getFullYear()}/${month}`,
            { group_id: group },
        );
        setNote(data.data);
        let getDays = [];
        for (const property in data.data) {
            getDays.push(property);
        }
        setSelectedDays(getDays);
    };

    const loadData = async (order, filed) => {
        try {
            const data = await axios.get(
                `/team/dashboard?page=${pageNumber}&page_size=${pageSize}&order=${order}&filed=${filed}&group_id=${group}&search=${searchValue}`,
            );

            setCount(data?.data?.total_pages);
            setTotalPages(data?.data?.total_pages);
            setTotalRecords(data?.data?.total_records);
            const dmember = data.data.data;
            setMembers(dmember);
            const users = dmember.map((user) => {
                return user.user_id;
            });
            setUser(users);
            setAlert(DEFAULT_ALERT);
        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message:
                    "You're not in a Team yet. Please ask your team admin to invite you in.",
            });
        }
    };

    const searchPlayers = async (order, filed) => {
        try {
            const data = await axios.get(
                `/team/dashboard?page=${pageNumber}&page_size=${pageSize}&order=${order}&field=${filed}&group_id=${group}&search=${searchValue}`,
            );
            setCount(data?.data?.total_pages);
            setTotalPages(data?.data?.total_pages);
            setTotalRecords(data?.data?.total_records);
            const dmember = data.data.data;
            setMembers(dmember);
            const users = dmember.map((user) => {
                return user.user_id;
            });
            setUser(users);
            setAlert(DEFAULT_ALERT);
        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message:
                    "You're not in a Team yet. Please ask your team admin to invite you in.",
            });
        }
    };

    useEffect(() => {
        // Clear selected users when the picked team changes
        dispatch(addUsers([]));
        getJournalData();
        // eslint-disable-next-line
    }, [group]);

    useEffect(() => {
        dispatch(addUsers([...userValue]));
        // eslint-disable-next-line
    }, [userValue]);

    useEffect(() => {
        if (searchValue?.length === 0) {
            searchPlayers("asc", "full_name");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    const handleWalkTestClick = () => {
        navigate("/detail-view", {
            state: {
                selectedPlayers: accessUser?.data || [],
            },
        });
    };

    return (
        <Grid container style={{ padding: "2rem" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} container>
                <Box sx={{ display: "flex", flex: 1 }}>
                    <Box sx={{ display: "flex", flex: 1 }}>
                        <Grid container spacing={1} alignItems={"center"}>
                            <Grid item>
                                <FormControlComponent
                                    groupData={groupData}
                                    setGroup={setGroup}
                                    group={group}
                                    formName={formName}
                                    variant="dashboard"
                                />
                            </Grid>
                            <Grid item>
                                <CompareMain
                                    setSearchValue={setSearchValue}
                                    setUserValue={setUserValue}
                                />
                            </Grid>
                            <Grid item>
                                <SearchButton
                                    searchValue={searchValue}
                                    searchPlayers={searchPlayers}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Grid container spacing={3} alignItems={"center"}>
                            <Grid item>
                                <span
                                    onClick={() => {
                                        if (selectedUserIds?.length > 0)
                                            setOpenDownloadReport(true);
                                    }}
                                    style={{
                                        color:
                                            selectedUserIds?.length > 0
                                                ? "var(--primary-theme-color)"
                                                : "var(--primary-text-color-80)",
                                        textDecorationLine:
                                            selectedUserIds?.length > 0
                                                ? "underline"
                                                : "underline",
                                        fontSize: "0.85rem",
                                        cursor:
                                            selectedUserIds?.length > 0
                                                ? "pointer"
                                                : "not-allowed",
                                        opacity:
                                            selectedUserIds?.length > 0
                                                ? 1
                                                : 0.6,
                                        pointerEvents:
                                            selectedUserIds?.length > 0
                                                ? "auto"
                                                : "none",
                                    }}
                                >
                                    Download Report
                                </span>
                            </Grid>
                            {/* <Grid item>
                <Dialog userValue={accessUser?.data} fData={fData} />
              </Grid> */}
                            <Tooltip
                                title={
                                    isCompareDisabled ? compareTooltipTitle : ""
                                }
                                disableHoverListener={!isCompareDisabled}
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: "#000000",
                                            color: "#FFFFFF",
                                            borderRadius: "10px",
                                            px: 2,
                                            py: 1,
                                            fontSize: "1rem",
                                            fontFamily: "Poppins",
                                            textAlign: "center",
                                            boxShadow:
                                                "0px 4px 10px rgba(0, 0, 0, 0.3)",
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: "#000000",
                                        },
                                    },
                                }}
                            >
                                <span>
                                    <Button
                                        variant="contained"
                                        onClick={handleWalkTestClick}
                                        disabled={isCompareDisabled}
                                        style={{
                                            backgroundColor: isCompareDisabled
                                                ? "var(--primary-button-disabled-background-color)"
                                                : "var(--primary-theme-color)",
                                            color: isCompareDisabled
                                                ? "var(--primary-button-disabled-text-color)"
                                                : "var(--primary-button-text-color)",
                                            opacity: isCompareDisabled ? 0.5 : 1,
                                            textTransform: "none",
                                            fontFamily: "Poppins",
                                            fontSize: "11px",
                                            whiteSpace: "nowrap",
                                            marginRight: 34,
                                            cursor: isCompareDisabled
                                                ? "not-allowed"
                                                : "pointer",
                                        }}
                                    >
                                        Compare
                                    </Button>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Box>
                </Box>
                <Box
                    sx={{
                        width: {
                            xs: "0px",
                            sm: "0px",
                            md: "5px",
                            lg: "344px",
                        },
                        display: "flex",
                        justifyContent: "flex-end",
                        marginLeft: "auto",
                        alignItems: "center",
                    }}
                >
                    {/* <Button
            variant="contained"
            onClick={handleWalkTestClick}
            style={{
              backgroundColor: "#0F9BB0",
              color: "white",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: "11px",
              whiteSpace: "nowrap",
              marginRight: "9px",
            }}
          >
            6-Minute Walk Test
          </Button> */}
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} container>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        columnGap: "1rem", // increase horizontal space between table and calendar
                    }}
                >
                    <Box sx={{ flex: "1" }}>
                        <MainTable
                            accessUser={accessUser}
                            group={group}
                            getJournalData={getJournalData}
                            members={members}
                            fData={fData}
                            setFData={setFData}
                            loadData={loadData}
                            count={count}
                            user={user}
                            setPageNumber={setPageNumber}
                            pageNumber={pageNumber}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalPages={totalPages}
                            totalRecords={totalRecords}
                        />
                    </Box>
                    <Box
                        sx={{
                            padding: "0.3rem",
                            minWidth: "350px",
                            width: "350px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                        }}
                    >
                        <MainCalendar
                            selectedDays={selectedDays}
                            date={date}
                            setDate={setDate}
                            getJournalData={getJournalData}
                        />
                        <NotesDisplay
                            setOpen={setOpen}
                            note={note}
                            date={date}
                            setNoteDetails={setNoteDetails}
                            setReadJournal={setReadJournal}
                        />
                    </Box>
                </Box>
            </Grid>
            {alert.showAlert && (
                <Alert
                    severity={alert.severity}
                    onClose={() =>
                        setAlert({
                            ...alert,
                            showAlert: false,
                        })
                    }
                >
                    {alert.message}
                </Alert>
            )}

            <JournalAddNote
                getJournalData={getJournalData}
                selectedDate={date}
                noteDetails={noteDetails}
                readJournal={readJournal}
                setReadJournal={setReadJournal}
                setOpen={setOpen}
                open={open}
            />
            <DownloadReportMain
                setOpen={setOpenDownloadReport}
                open={openDownloadReport}
            />
        </Grid>
    );
}
